module.exports = __webpack_public_path__ + "img/pos.50c40a5e.png";